export default "__VITE_ASSET__DkgzyOnM__"